import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/content";
import { Reveal, Eyebrow } from "../Reveal";

const Card = ({ s, i }) => (
  <Reveal
    delay={(i % 2) * 0.1}
    className={`group relative overflow-hidden border border-border min-h-[320px] md:min-h-[300px] ${s.span}`}
  >
    <div className="absolute inset-0 overflow-hidden">
      <img
        src={s.img}
        alt={s.title}
        className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[900ms] ease-out"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-black/10" />
    </div>
    <div className="relative z-10 h-full flex flex-col justify-between p-7 md:p-9">
      <div className="flex items-center justify-between">
        <span className="font-display text-white/60 text-3xl">{s.tag}</span>
        <ArrowUpRight className="w-6 h-6 text-white/70 group-hover:text-primary group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500" />
      </div>
      <div>
        <h3 className="font-display text-white text-3xl md:text-4xl font-light leading-none mb-3">
          {s.title}
        </h3>
        <p className="text-white/75 text-sm md:text-base font-light max-w-md leading-relaxed">
          {s.copy}
        </p>
      </div>
    </div>
  </Reveal>
);

export const Services = () => (
  <section id="services" data-testid="services" className="bg-background py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
        <div>
          <Eyebrow>What we handle</Eyebrow>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-5xl sm:text-6xl md:text-7xl font-light tracking-tight leading-[0.95] mt-4"
          >
            Every group,
            <br />
            <span className="text-primary italic">one block.</span>
          </motion.h2>
        </div>
        <p className="text-muted-foreground max-w-sm font-light leading-relaxed">
          From boardrooms to reunions, we specialize in the logistics of keeping your people together
          under one roof.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 md:auto-rows-[300px]">
        {SERVICES.map((s, i) => (
          <Card key={s.id} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
